import { SLIDE } from '../constants'
import _ from 'lodash'
import { defaultSlideState, defaultCaption, defaultCaptionState } from '../../defaulState'
import { incrementUsingStamp } from '../../Utils/GA'
import { hexToRgba } from 'hex-and-rgba'
import { getRightPropertyValue } from '../../Utils/helpers'

// копировани вложенных элементов
const copyInnerCaptions = (allCaptions, oldId, newId, isMobile) => {
    const innerCaptions = allCaptions.filter(innerCaption => innerCaption.boxId === oldId)
    innerCaptions.map(innerCaption => {
        // обязательно клонировать, иначе у старой капчи тоже всё меняется
        const newInnerCaption = _.cloneDeep(innerCaption)
        const oldInnerId = newInnerCaption.id
        const newInnerId = `id-${Date.now() + parseInt(Math.random() * 1000)}`
        newInnerCaption.boxId = newId

        if (newInnerCaption.type === 'box') {
            copyInnerCaptions(allCaptions, oldInnerId, newInnerId)
        }
        // для того, чтобы капча конвертировалась под мобильный вид, когда она впервые оказывается в мобильном редакторе
        // если капча уже редактировалась в мобильном виде, то для скопированной капчи адаптируем только позиционирование и размеры 
        if (!isMobile && !newInnerCaption.needMobileConvert) {
            newInnerCaption.needMobileConvert = true
            newInnerCaption.needMobileConvertOnlyPosition = true
        }
        newInnerCaption.id = newInnerId
        newInnerCaption.index = allCaptions.length
        allCaptions.push(newInnerCaption)
    })
}



const slideReducer = (state = defaultSlideState, action) => {
    let _newState = {}
    let actionForHistory = {}

    switch (action.type) {

        case SLIDE.INIT_SLIDE_SETTINGS:
            _newState = _.cloneDeep(action.payload)
            break;

        case SLIDE.UPDATE_SLIDE_SETTINGS:
            _newState = _.cloneDeep(action.payload)
            break;

        case SLIDE.ADD_CAPTION: {
            _newState = _.cloneDeep(state)
            const { caption, isMobile } = action.payload
            let positionProp = isMobile ? 'mobilePosition' : 'position'
            let delta = isMobile ? 10 : 20
            let startPosition = isMobile ? 10 : 30
            let workspaceSizes = document.querySelector('#workspace').getBoundingClientRect()
            let i = 0
            // обходим все капчи и проверяем, не совпадает ли положение новой капчи с уже добавленной. Если да, то смещаем новую капчу на величину delta
            // ограничиваем смещение 50 капчами, потом они будут лепиться друг на друга
            while (_newState.captions.some(el => el[positionProp].x === caption[positionProp].x && el[positionProp].y === caption[positionProp].y) && i < 50) {

                caption[positionProp].x += delta
                caption[positionProp].y += delta

                if (workspaceSizes.width > workspaceSizes.height) {

                    if (caption[positionProp].y + caption.height > workspaceSizes.height) {
                        caption[positionProp].y -= delta * 2
                    }
                    if (caption[positionProp].y < 0) {
                        caption[positionProp].y += delta * 2
                    }
                    if (caption[positionProp].x + caption.width > workspaceSizes.width) {
                        caption[positionProp].x = delta + startPosition
                        caption[positionProp].y = startPosition
                    }
                } else {
                    if (caption[positionProp].x + caption.width > workspaceSizes.width) {
                        caption[positionProp].x -= delta * 2
                    }
                    if (caption[positionProp].x < 0) {
                        caption[positionProp].x += delta * 2
                    }
                    if (caption[positionProp].y + caption.height > workspaceSizes.height) {
                        caption[positionProp].y = delta + startPosition
                        caption[positionProp].x = startPosition
                    }
                }
                i++
            }

            _newState.captions.push(caption)
        }
            break;

        case SLIDE.ADD_CAPTION_IN_BOX:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.captionIndex].boxId = action.payload.boxId
            if (action.payload.boxId === '') {
                _newState.captions[action.payload.captionIndex].position.x = action.payload.position.x
                _newState.captions[action.payload.captionIndex].position.y = action.payload.position.y
            } else {
                _newState.captions[action.payload.captionIndex].position.relativeX = action.payload.position.relativeX
                _newState.captions[action.payload.captionIndex].position.relativeY = action.payload.position.relativeY
            }
            break;

        case SLIDE.PASTE_CAPTIONS: {
            _newState = _.cloneDeep(state)
            const { captions, isMobile } = action.payload
            captions.map(caption => {
                // если десктоп, то смещение только на десктопе, а на мобилке элемент накладывается на оригинальный
                // т.к. не можем посчитать размеры и положение в DOM
                // если мобилка, соответственно смещение только на мобилке добавляется
                let positionProp = isMobile ? 'mobilePosition' : 'position'
                let axisPropX = 'x'
                let axisPropY = 'y'
                const delta = 20
                const deltaMobile = 10
                let workspaceSizes = document.querySelector('#workspace').getBoundingClientRect()
                const desktopDims = { width: _newState.widgetData.width, height: _newState.widgetData.height }
                const mobileDims = { width: _newState.widgetData.mobileWidth, height: _newState.widgetData.mobileHeight }
                const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', false, caption)
                const captionPositionMobile = getRightPropertyValue(desktopDims, mobileDims, 'position', true, caption)
                // если вставка происходит несколько раз подряд, то происходит смещение относительно предыдущего вставленного элемента, 
                // а не оригинального, т.к. массив captions переписывается с новыми значениями
                const captionElement = document.querySelector(`[data-caption-id="${caption.id}"]`)
                if (captionElement) {
                    const captionSizes = captionElement.getBoundingClientRect()
                    // если элемент находится внутри бокса, то смещение происходит в пределах этого бокса
                    if (caption.boxId) {
                        axisPropX = 'relativeX'
                        axisPropY = 'relativeY'
                        workspaceSizes = document.querySelector(`[data-caption-id=${caption.boxId}]`).getBoundingClientRect()
                    }
                    if (isMobile && !caption.mobilePosition) {
                        caption.mobilePosition = captionPositionMobile
                    }
                    if (captionSizes.bottom + delta < workspaceSizes.bottom) {
                        caption.position[axisPropY] += delta
                        if (isMobile) caption.mobilePosition[axisPropY] += deltaMobile
                    }
                    else if (captionSizes.top - delta > workspaceSizes.top) {
                        caption.position[axisPropY] -= delta
                        if (isMobile) caption.mobilePosition[axisPropY] -= deltaMobile
                    }
                    if (captionSizes.right + delta < workspaceSizes.right) {
                        caption.position[axisPropX] += delta
                        if (isMobile) caption.mobilePosition[axisPropX] += deltaMobile
                    }
                    else if (captionSizes.left - delta > workspaceSizes.left) {
                        caption.position[axisPropX] -= delta
                        if (isMobile) caption.mobilePosition[axisPropX] -= deltaMobile
                    }
                }
                const oldId = caption.id
                const newId = `id-${Date.now() + parseInt(Math.random() * 1000)}`
                // если копируемый элемент - бокс, то копируем все вложенные элементы
                if (caption.type === 'box') {
                    // copyInnerCaptions(_newState.captions, oldId, newId, isMobile)
                    const boxChildren = captions.filter(c => c.boxId === oldId)
                    for (let child of boxChildren) {
                        child.boxId = newId
                    }
                }
                // для того, чтобы капча конвертировалась под мобильный вид, когда она впервые оказывается в мобильном редакторе
                // если капча уже редактировалась в мобильном виде, то для скопированной капчи адаптируем только позиционирование и размеры 
                if (!isMobile && !caption.needMobileConvert) {
                    caption.needMobileConvert = true
                    caption.needMobileConvertOnlyPosition = true
                }
                caption.id = newId
                // ставим индекс последнего элемента + 1
                caption.index = _newState.captions.length
                caption.captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                _newState.captions.push(caption)
            })
            _newState.rerenderRightPanelSetting = Date.now()
        }
            break;

        case SLIDE.ADD_POINT:
            _newState = _.cloneDeep(state)
            const newPoint = {
                curvePoints: [
                    { x: 0, y: 0, },
                    { x: action.payload.position.x - 20, y: action.payload.position.y - 20 }
                ],
                x: action.payload.position.x,
                y: action.payload.position.y,
            }
            _newState.captions[action.payload.boxIndex].pointsArray.splice(action.payload.pointIndex + 1, 0, newPoint)
            break;

        case SLIDE.DELETE_CAPTION:
            _newState = _.cloneDeep(state)
            let selectedCaptionsData = new Map()

            action.payload.captionSelectedArray.map(index => {
                const captionData = {
                    id: _newState.captions[index].id,
                    index: _newState.captions[index].index,
                    type: _newState.captions[index].type,
                }
                selectedCaptionsData.set(index, captionData)
            })

            function deleteAllCaptionInBox(boxId) {
                _newState.captions.map(caption => {
                    if (caption.type === 'box' && boxId == caption.boxId) {
                        deleteAllCaptionInBox(caption.id)
                    }
                    _newState.captions = _newState.captions.filter(caption => {
                        return !(boxId == caption.boxId)
                    })
                })

            }

            action.payload.captionSelectedArray.map(index => {
                const captionData = selectedCaptionsData.get(index)
                if (captionData.type === 'box') {
                    deleteAllCaptionInBox(captionData.id)
                }
            })



            _newState.captions = _newState.captions.filter(caption => {
                return !action.payload.captionSelectedArray.some(index => {

                    return selectedCaptionsData.get(index).id == caption.id
                })
            })


            break;

        case SLIDE.DELETE_CAPTION_BY_CAPTION_INDEX:
            _newState = _.cloneDeep(state)
            _newState.captions.splice(action.payload.index, 1)
            break;

        case SLIDE.DELETE_POINT:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.captionIndex].pointsArray.splice(action.payload.pointIndex, 1)
            break;

        case SLIDE.CHANGE_CAPTION_POSITION:
            _newState = _.cloneDeep(state)
            // заодно обновляем размер элемента, чтобы исключить возможные ошибки в пересчёте размеров
            {
                // console.log('captionInDom',captionInDom.height);
                const movedCaption = _newState.captions[action.payload.captionIndex]
                let captionInDom = document.getElementById(`caption-${action.payload.captionIndex}`).getBoundingClientRect()
                if (movedCaption.type === 'image') {
                    captionInDom = document.getElementById(`caption-${action.payload.captionIndex}`).parentElement.getBoundingClientRect()
                }
                switch (action.payload.viewType) {
                    case 'desktop':
                        movedCaption.position.x = action.payload.lastX
                        movedCaption.position.y = action.payload.lastY
                        // movedCaption.width = Math.ceil(captionInDom.width);
                        // movedCaption.height = Math.ceil(captionInDom.height);
                        if (captionInDom && (movedCaption.type === 'text' || movedCaption.type === 'button')) {
                            movedCaption.height = Math.round(captionInDom.height / (action.payload.mobileViewScale / 100));
                        }
                        break;

                    case 'mobile':
                        if (!movedCaption.mobilePosition) {
                            movedCaption.mobilePosition = { x: 0, y: 0 }
                        }
                        movedCaption.mobilePosition.x = action.payload.lastX
                        movedCaption.mobilePosition.y = action.payload.lastY
                        // округляю round, т.к. при scale погрешность размера приходит около 0.00003
                        // movedCaption.mobileWidth = Math.round(captionInDom.width / (action.payload.mobileViewScale / 100));
                        // movedCaption.mobileHeight = Math.round(captionInDom.height / (action.payload.mobileViewScale / 100));
                        if (captionInDom && (movedCaption.type === 'text' || movedCaption.type === 'button')) {
                            movedCaption.mobileHeight = Math.round(captionInDom.height / (action.payload.mobileViewScale / 100));
                        }
                        if (movedCaption.needMobileConvert) {
                            delete movedCaption.needMobileConvert
                        }
                        break;
                }
                _newState.captions[action.payload.captionIndex] = movedCaption
                _newState.captions[action.payload.captionIndex].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                // console.log('_newState.captions[action.payload.captionIndex]',_newState.captions[action.payload.captionIndex]);
            }
            break;

        case SLIDE.CHANGE_CAPTION_RELATIVE_POSITION:
            _newState = _.cloneDeep(state)
            // заодно обновляем размер элемента, чтобы исключить возможные ошибки в пересчёте размеров
            {
                const captionInDom = document.getElementById(`caption-${action.payload.captionIndex}`).getBoundingClientRect()
                const movedCaption = _newState.captions[action.payload.captionIndex]
                switch (action.payload.viewType) {
                    case 'desktop':
                        movedCaption.position.relativeX = action.payload.lastX
                        movedCaption.position.relativeY = action.payload.lastY
                        // _newState.captions[action.payload.captionIndex].width = Math.ceil(captionInDom.width);
                        if (captionInDom && (movedCaption.type === 'text' || movedCaption.type === 'button')) {
                            movedCaption.height = Math.round(captionInDom.height / (action.payload.mobileViewScale / 100));
                        }
                        break;

                    case 'mobile':
                        if (!movedCaption.mobilePosition) {
                            const desktopDims = { width: state.widgetData.originalWidth, height: state.widgetData.originalHeight }
                            const mobileDims = { width: state.widgetData.mobileWidth, height: state.widgetData.mobileHeight }
                            movedCaption.mobilePosition = getRightPropertyValue(desktopDims, mobileDims, 'position', true, movedCaption)
                        }
                        movedCaption.mobilePosition.relativeX = action.payload.lastX
                        movedCaption.mobilePosition.relativeY = action.payload.lastY
                        
                        // _newState.captions[action.payload.captionIndex].mobileWidth = Math.round(captionInDom.width / (action.payload.mobileViewScale / 100));
                        if (captionInDom && (movedCaption.type === 'text' || movedCaption.type === 'button')) {
                            movedCaption.mobileHeight = Math.round(captionInDom.height / (action.payload.mobileViewScale / 100));
                        }
                        if (movedCaption.needMobileConvert) {
                            delete movedCaption.needMobileConvert
                        }
                        break;
                }
                movedCaption.captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                _newState.captions[action.payload.captionIndex] = movedCaption
            }
            break;

        case SLIDE.CHANGE_SOME_CAPTIONS_POSITION:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                switch (action.payload.viewType) {
                    case 'desktop':
                        _newState.captions[index].position = action.payload.newPositions.get(_newState.captions[index].index)
                        break;

                    case 'mobile':
                        _newState.captions[index].mobilePosition = action.payload.newPositions.get(_newState.captions[index].index)
                        if (_newState.captions[index].needMobileConvert) {
                            delete _newState.captions[index].needMobileConvert
                        }
                        break;
                }
                _newState.captions[index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
            })

            break;

        case SLIDE.CHANGE_CAPTION_DIMESIONS:
            _newState = _.cloneDeep(state)

            switch (action.payload.viewType) {

                case 'desktop':
                    _newState.captions[action.payload.captionIndex].width = action.payload.newVal.width
                    _newState.captions[action.payload.captionIndex].height = action.payload.newVal.height
                    if (_newState.captions[action.payload.captionIndex].type === 'image') {
                        _newState.captions[action.payload.captionIndex].crop.editedByCaption = false
                    }
                    break;

                case 'mobile':
                    _newState.captions[action.payload.captionIndex].mobileWidth = action.payload.newVal.width
                    _newState.captions[action.payload.captionIndex].mobileHeight = action.payload.newVal.height
                    if (_newState.captions[action.payload.captionIndex].type === 'image') {
                        if (_newState.captions[action.payload.captionIndex].mobileCrop) {
                            _newState.captions[action.payload.captionIndex].mobileCrop.editedByCaption = false
                        } else {
                            _newState.captions[action.payload.captionIndex].crop.editedByCaption = false
                        }
                    }
                    if (_newState.captions[action.payload.captionIndex].needMobileConvert) {
                        delete _newState.captions[action.payload.captionIndex].needMobileConvert
                    }
                    break;
            }
            // switch (action.payload.viewType) {

            //     case 'desktop':
            //         if (_newState.captions[action.payload.captionIndex].type === 'box' || _newState.captions[action.payload.captionIndex].type === 'shape') {
            //             _newState.captions[action.payload.captionIndex].width += action.payload.newVal.width
            //             _newState.captions[action.payload.captionIndex].height += action.payload.newVal.height
            //         } else {
            //             _newState.captions[action.payload.captionIndex].width = action.payload.newVal.width
            //             _newState.captions[action.payload.captionIndex].height = action.payload.newVal.height
            //         }
            //         break;

            //     case 'mobile':
            //         if (_newState.captions[action.payload.captionIndex].type === 'box' || _newState.captions[action.payload.captionIndex].type === 'shape') {
            //             _newState.captions[action.payload.captionIndex].mobileWidth += action.payload.newVal.width
            //             _newState.captions[action.payload.captionIndex].mobileHeight += action.payload.newVal.height
            //         } else {
            //             _newState.captions[action.payload.captionIndex].mobileWidth = action.payload.newVal.width
            //             _newState.captions[action.payload.captionIndex].mobileHeight = action.payload.newVal.height
            //         }
            //         break;
            // }
            break;

        case SLIDE.CHANGE_ARRAY_CAPTIONS_DIMESIONS:
            _newState = _.cloneDeep(state)
            action.payload.selectedCaptions.forEach((value, key) => {
                if (action.payload.viewType === 'mobile') {
                    _newState.captions[key].mobileWidth = value.width
                    _newState.captions[key].mobileHeight = value.height
                    if (_newState.captions[key].needMobileConvert) {
                        delete _newState.captions[key].needMobileConvert
                    }
                } else {
                    _newState.captions[key].width = value.width
                    _newState.captions[key].height = value.height
                }
            })
            // console.log('_newState.captions arr',_newState.captions);
            break;

        case SLIDE.SET_CAPTION_SIZE:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.captionIndex] = { ..._newState.captions[action.payload.captionIndex], ...action.payload.newVal }

            break;

        case SLIDE.APPLY_CAPTIONS_SIZES_IN_FIRST_LOAD:
            // после конвертации настроек нужно получить размеры капч, а в старой версии размеров не было
            _newState = _.cloneDeep(state)
            _newState.captions = _newState.captions.map(caption => {
                caption.width = action.payload[caption.index].width + 2
                caption.height = action.payload[caption.index].height
                caption.shadow = {
                    angle: 120,
                    distance: 2,
                    x: 2,
                    y: 1,
                    blur: 4,
                    size: 1,
                    color: 'rgba(0,0,0,0.7)',
                }
                return caption
            })
            actionForHistory = {
                captions: _newState.captions,
                backgroundColor: _newState.backgroundColor,
                backgroundType: _newState.backgroundType,
                backgroundGradient: _newState.backgroundGradient,
                hasBackgroundShadow: _newState.hasBackgroundShadow,
                backgroundShadow: _newState.backgroundShadow,
            }
            // заменяем первый и единственный шаг, чтобы шагая назад не получить неправильные размеры капч
            _newState.actions = [actionForHistory]
            delete _newState.slideJustTranspiled

            break;

        case SLIDE.CONVERT_BOX_POINT_POSITION:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.boxIndex].pointsArray.map((point) => {
                point.x *= action.payload.newScale.x
                point.y *= action.payload.newScale.y
                if (point.curvePoints != undefined) {
                    point.curvePoints.map(curvePoint => {
                        curvePoint.x *= action.payload.newScale.x
                        curvePoint.y *= action.payload.newScale.y
                    })
                }
            })

            break;

        case SLIDE.CHANGE_BOX_POINT_POSITION:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.boxIndex].pointsArray[action.payload.pointIndex] = action.payload.newPoint
            break;

        case SLIDE.CHANGE_BOX_EDITING_DIMANSIONS:
            _newState = _.cloneDeep(state)
            switch (action.payload.viewType) {

                case 'desktop':
                    _newState.captions[action.payload.captionIndex].editedWidth = action.payload.newVal.width
                    _newState.captions[action.payload.captionIndex].editedHeight = action.payload.newVal.height

                    break;

                case 'mobile':
                    _newState.captions[action.payload.captionIndex].mobileWidth += action.payload.newVal.width
                    _newState.captions[action.payload.captionIndex].mobileHeight += action.payload.newVal.height
                    break
            }
            break;
        case SLIDE.APPLY_STYLE:
            _newState = _.cloneDeep(state);
            if (_newState.captions[action.payload.index].type === action.payload.style.type && _newState.captions[action.payload.index].type != undefined) {
                const styles = ['backgroundColor', 'backgroundColorHover', 'borderColor', 'borderColorHover', 'borderRadius', 'borderWidth',
                    'fontColor', 'fontColorHover', 'fontFamily', 'fontSize', 'hasShadow', 'isHover', 'lineHeight', 'padding', 'mobilePadding',
                    'mobileBorderRadius', 'mobileBorderWidth', 'mobileFontSize', 'mobileLineHeight', 'shadow', 'style', 'textHasShadow', 'textShadow',
                    'letterCase', 'letterSpacing', 'mobileLetterSpacing', 'textStroke', 'lineColors', 'iconOn', 'iconSettings', 'glassEffect', 'invertEffect', 'grayscaleEffect', 'blur']
                styles.forEach(styleName => {
                    // если есть такое свойство, то копируем его значение
                    if (action.payload.style[styleName] !== undefined) {
                        _newState.captions[action.payload.index][styleName] = action.payload.style[styleName]
                    }
                    if (_newState.captions[action.payload.index].type === 'shape' || _newState.captions[action.payload.index].type === 'box') {
                        const hasCustomShape =_newState.captions[action.payload.index].shape !== undefined && _newState.captions[action.payload.index].shape !== 'rectangle'
                        if (!hasCustomShape) {
                            _newState.captions[action.payload.index].effectType = action.payload.style.effectType
                        }
                    }
                })
                // если капча, получающая стили, ещё не настраивалась в мобильном виде, а капча, дающая стили, уже настраивалась,
                // то, чтобы не сбить скопированные настройки, для получающей капчи оставляем адаптацию только положения
                if (!action.payload.style.needMobileConvert && _newState.captions[action.payload.index].needMobileConvert) {
                    _newState.captions[action.payload.index].needMobileConvertOnlyPosition = true
                }
                incrementUsingStamp()
            } else {
                _newState.errorMessage = 'You can\'t copy style from different type of caption'
                _newState.error = true
                break;
            }
            break;


        //============================!!!Slide!!!==================================

        case SLIDE.CHANGE_SLIDE_NAME:
            _newState = _.cloneDeep(state);
            _newState.slideName = action.payload
            break;

        case SLIDE.CHANGE_SLIDE_BACKGROUND:
            _newState = _.cloneDeep(state);
            // console.log('action.payload',action.payload);
            _newState.backgroundColor = action.payload.colorValue
            _newState.backgroundType = action.payload.type
            _newState.backgroundGradient = action.payload.gradientLayers

            // _newState.backgroundColor = action.payload
            break;

        case SLIDE.CHANGE_SLIDE_HAS_BACKGROUND_SHADOW:
            _newState = _.cloneDeep(state);
            _newState.hasBackgroundShadow = action.payload
            break;

        case SLIDE.CHANGE_SLIDE_BACKGROUND_SHADOW:
            _newState = _.cloneDeep(state);
            _newState.backgroundShadow = action.payload
            break;

        //==================================!!!Link!!!==============================

        case SLIDE.CHANGE_LINK_ON_CLICK:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if ((_newState.captions[index].type === 'button') || (_newState.captions[index].type === 'text') || (_newState.captions[index].type === 'image')) {
                    _newState.captions[index].onClick = action.payload.newVal
                }

            })
            break;

        case SLIDE.CHANGE_LINK_TYPE:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if ((_newState.captions[index].type === 'button') || (_newState.captions[index].type === 'text') || (_newState.captions[index].type === 'image')) {
                    _newState.captions[index].linkType = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_LINK:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if ((_newState.captions[index].type === 'button') || (_newState.captions[index].type === 'text') || (_newState.captions[index].type === 'image')) {
                    // _newState.captions[index].link = action.payload.newVal
                    _newState.captions[index].linkTo = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_IS_HOVER:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type != 'box') {
                    _newState.captions[index].isHover = action.payload.newVal
                }
            })
            break;

        //=============================!!!Border!!!===============================

        case SLIDE.CHANGE_BORDER_WIDTH:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                switch (action.payload.viewType) {
                    case 'desktop':
                        _newState.captions[index].borderWidth = action.payload.newVal
                        break;

                    case 'mobile':
                        _newState.captions[index].mobileBorderWidth = action.payload.newVal
                        break;
                }
            })
            break;

        case SLIDE.CHANGE_BORDER_RADIUS:
            _newState = _.cloneDeep(state)
            let num = ''
            let obj = {}
            // радиус может прийти либо общим числом, либо для каждого угла отдельно
            if (typeof action.payload.newVal === 'number') {
                num = action.payload.newVal
                obj = { leftTop: num, rightTop: num, leftBottom: num, rightBottom: num }
            } else {
                obj = action.payload.newVal
                num = Math.min(obj.leftTop, obj.rightTop, obj.leftBottom, obj.rightBottom)
            }


            action.payload.captionSelectedArray.map((index) => {
                switch (action.payload.viewType) {
                    case 'desktop':
                        if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                            _newState.captions[index].borderRadius = obj
                        } else {
                            _newState.captions[index].borderRadius = num
                        }
                        break;

                    case 'mobile':
                        if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                            _newState.captions[index].mobileBorderRadius = obj
                        } else {
                            _newState.captions[index].mobileBorderRadius = num
                        }
                        break;
                }
                _newState.captions[index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
            })
            break;

        case SLIDE.CHANGE_BORDER_COLOR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].borderColor = action.payload.newVal
            })
            break;

        case SLIDE.CHANGE_BORDER_COLOR_HOVER:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type != 'box') {
                    _newState.captions[index].borderColorHover = action.payload.newVal
                }
            })
            break;

        //================================!!!Background!!!=======================================

        case SLIDE.CHANGE_BACKGROUND_COLOR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].backgroundColor = action.payload.newVal

            })
            break;
        case SLIDE.CHANGE_OVERLAY_COLOR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].overlayColor = action.payload.newVal

            })
            break;
        case SLIDE.CAPTION_IMAGE_CHANGE:
            _newState = _.cloneDeep(state)
            const data = action.payload.value
            const ratio = data.width / data.height

            const dimensions = { height: 200, width: 200 * ratio }

            if (dimensions.width > 200 && data.width != 0 && data.height != 0) {
                dimensions.width = 200
                dimensions.height = 200 / ratio
            }
            // _newState.captions[action.payload.index].width = dimensions.width
            // _newState.captions[action.payload.index].height = dimensions.height
            _newState.captions[action.payload.index].relativeUri = data.relativeUri
            _newState.captions[action.payload.index].imageURL = 'https://media.wix.com/media/' + data.relativeUri
            _newState.captions[action.payload.index].originalDimensions = { width: data.width, height: data.height }
            if (_newState.captions[action.payload.index].crop) {
                _newState.captions[action.payload.index].crop = {
                    centerPoint: { x: .5, y: .5 },
                    scale: 100
                }
            }
            if (_newState.captions[action.payload.index].mobileCrop) {
                delete _newState.captions[action.payload.index].mobileCrop
            }
            _newState.captions[action.payload.index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)

            break;
        case SLIDE.SET_BLUR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    _newState.captions[index].blur = action.payload.newVal
                }

            })
            break;
        case SLIDE.TOGGLE_GLASS_BLUR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].glassBlur = action.payload.newVal

            })
            break;
        case SLIDE.CHANGE_CAPTION_EFFECT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    const hasCustomShape = _newState.captions[index].shape && _newState.captions[index].shape !== 'rectangle'
                    if (!hasCustomShape) {
                        _newState.captions[index].effectType = action.payload.newVal
                    }
                }

            })
            break;

        case SLIDE.SET_GLASS_EFFECT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    _newState.captions[index].glassEffect = action.payload.newVal
                }

            })
            break;

        case SLIDE.SET_INVERT_EFFECT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    _newState.captions[index].invertEffect = action.payload.newVal
                }

            })
            break;

        case SLIDE.SET_GRAYSCALE_EFFECT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    _newState.captions[index].grayscaleEffect = action.payload.newVal
                }

            })
            break;
        case SLIDE.CHANGE_CAPTION_CUBE_HEIGHT:
            _newState = _.cloneDeep(state)
            if (action.payload.isMobile) {
                _newState.captions[action.payload.captionIndex].mobileCubeHeight = action.payload.newVal
                _newState.captions[action.payload.captionIndex].cubeHeightChangedWithoutMobile = false
            } else {
                _newState.captions[action.payload.captionIndex].cubeHeight = action.payload.newVal
                if (_newState.captions[action.payload.captionIndex].mobileCubeHeight != undefined) {
                    _newState.captions[action.payload.captionIndex].cubeHeightChangedWithoutMobile = true
                }
            }
            break;

        case SLIDE.CHANGE_BACKGROUND_COLOR_HOVER:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type != 'box') {
                    _newState.captions[index].backgroundColorHover = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_SVG_SRC:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'shape') {
                    _newState.captions[index].svgSrc = action.payload.newVal
                }
            })
            break;

        case SLIDE.SET_IMAGE_CAPTION_CROP:
            _newState = _.cloneDeep(state)
            if (action.payload.value.crop && _newState.captions[action.payload.index].type === 'image') {
                if (action.payload.isMobile) {
                    _newState.captions[action.payload.index].mobileCrop = action.payload.value.crop
                } else {
                    _newState.captions[action.payload.index].crop = action.payload.value.crop
                }
            }
            if (action.payload.value.overlayColor) {
                _newState.captions[action.payload.index].overlayColor = action.payload.value.overlayColor
            }

            break;

        case SLIDE.CHANGE_PADDING:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type != 'box') {
                    switch (action.payload.viewType) {
                        case 'desktop':
                            _newState.captions[index].padding = action.payload.newVal
                            break;

                        case 'mobile':
                            _newState.captions[index].mobilePadding = action.payload.newVal
                            break;
                    }
                }
            })
            break;

        //===============================!!!Animation!!!=======================================

        case SLIDE.CHANGE_HOVER_ANIMATION:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'button') {
                    _newState.captions[index].animation = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_ANIMATION_IN:
            _newState = _.cloneDeep(state)

            const editingCaptionType = _newState.captions[action.payload.editingCaptionIndex].type
            action.payload.captionSelectedArray.map((index) => {
                let mayUpdate = false;
                const oldAnimationIn = _newState.captions[index].animationIn
                if (editingCaptionType === 'text') {
                    mayUpdate = editingCaptionType === _newState.captions[index].type
                } else {
                    mayUpdate = _newState.captions[index].type != 'text'
                }
                if (action.payload.newVal === 'none') {
                    mayUpdate = true
                }

                if (mayUpdate) {
                    _newState.captions[index].animationIn = action.payload.newVal
                    if (action.payload.newVal === 'typing' || action.payload.newVal.includes('countdown') || action.payload.newVal.includes('credits')) {
                        // если переключаемся между анимациями, у которых исползуются массивы текста, то ничего с текстом не делаем
                        if (!(oldAnimationIn === 'typing' || oldAnimationIn.includes('countdown') || oldAnimationIn.includes('credits'))) {
                            // если уже есть сохранённый массив с текстом, то используем его
                            if (_newState.captions[index].textArray) {
                                _newState.captions[index].textArray[0] = _newState.captions[index].text
                            } else {
                                // если нет массива, то создаём его и вторым элементом ставим дефолтный текст
                                _newState.captions[index].textArray = [_newState.captions[index].text, 'Second Line']
                            }

                            // если есть объект с настройками для языков
                            if (_newState.captions[index].lang) {
                                const langObj = _newState.captions[index].lang
                                for (let key in langObj) {
                                    // console.log('key', key, 'value', langObj[key])
                                    langObj[key].textArray[0] = langObj[key].text
                                    langObj[key].text = langObj[key].textArray
                                }
                                _newState.captions[index].lang = langObj
                            }

                        }
                        _newState.captions[index].text = _newState.captions[index].textArray
                    } else {
                        if (typeof _newState.captions[index].text === 'object') {
                            _newState.captions[index].text = _newState.captions[index].text[0]

                            // если есть объект с настройками для языков
                            if (_newState.captions[index].lang) {
                                const langObj = _newState.captions[index].lang
                                for (let key in langObj) {
                                    // console.log('key', key, 'value', langObj[key])

                                    if (Array.isArray(langObj[key].text)) {
                                        langObj[key].text = langObj[key].text[0]
                                    }
                                }
                                _newState.captions[index].lang = langObj
                            }
                        }
                    }
                }
            })
            break;

        case SLIDE.CHANGE_ANIMATION_OUT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                const editingCaptionType = _newState.captions[action.payload.editingCaptionIndex].type
                let mayUpdate = false;
                if (editingCaptionType === 'text') {
                    mayUpdate = editingCaptionType === _newState.captions[index].type
                } else {
                    mayUpdate = _newState.captions[index].type != 'text'
                }

                if (mayUpdate) {
                    _newState.captions[index].animationOut = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_ANIMATION_IN_MODE:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'text') {
                    _newState.captions[index].animationModeIn = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_ANIMATION_OUT_MODE:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'text') {
                    _newState.captions[index].animationModeOut = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_ANIMATION_DELAY_IN:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].delayIn = action.payload.newVal

            })
            break;

        case SLIDE.CHANGE_ANIMATION_DELAY_OUT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].delayOut = action.payload.newVal

            })
            break;

        case SLIDE.CHANGE_ANIMATION_LOOP:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].isLoopAnimation = action.payload.newVal

            })
            break;

        //===============================!!!Typing Animations===================================


        case SLIDE.ADD_LINE:
            _newState = _.cloneDeep(state)
            if (
                _newState.captions[action.payload].animationIn === 'typing'
                || _newState.captions[action.payload].animationIn.includes('countdown')
                || _newState.captions[action.payload].animationIn.includes('credits')
            ) {
                // if (_newState.captions[action.payload].animationIn === 'typing') {
                _newState.captions[action.payload].text.push('New Line!')
                _newState.captions[action.payload].textArray = [..._newState.captions[action.payload].text]

                const textArrLength = _newState.captions[action.payload].text.length
                let lineColorsArray = Array.isArray(_newState.captions[action.payload].lineColors) ? [..._newState.captions[action.payload].lineColors] : []

                if (Array.isArray(lineColorsArray) && lineColorsArray.length < textArrLength) {
                    lineColorsArray = [...lineColorsArray, ...Array(textArrLength - lineColorsArray.length).fill(_newState.captions[action.payload].fontColor)]
                }

                _newState.captions[action.payload].lineColors = [...lineColorsArray]
            }
            break;

        case SLIDE.CHANGE_LINE_TEXT:
            _newState = _.cloneDeep(state)
            if (
                _newState.captions[action.payload.editingCaptionIndex].animationIn === 'typing'
                || _newState.captions[action.payload.editingCaptionIndex].animationIn.includes('countdown')
                || _newState.captions[action.payload.editingCaptionIndex].animationIn.includes('credits')
            ) {
                // if (_newState.captions[action.payload.editingCaptionIndex].animationIn === 'typing') {
                _newState.captions[action.payload.editingCaptionIndex].text[action.payload.lineIndex] = action.payload.newText
                _newState.captions[action.payload.editingCaptionIndex].textArray = _newState.captions[action.payload.editingCaptionIndex].text
            }
            break;

        case SLIDE.DELETE_LINE:
            _newState = _.cloneDeep(state)
            if (
                _newState.captions[action.payload.editingCaptionIndex].animationIn === 'typing'
                || _newState.captions[action.payload.editingCaptionIndex].animationIn.includes('countdown')
                || _newState.captions[action.payload.editingCaptionIndex].animationIn.includes('credits')
            ) {
                // if (_newState.captions[action.payload.editingCaptionIndex].animationIn === 'typing') {
                try {
                    let i = action.payload.editingCaptionIndex
                    _newState.captions[i].text.splice(action.payload.lineIndex, 1)
                    _newState.captions[i].textArray = [..._newState.captions[i].text]
                    if (Array.isArray(_newState.captions[i].lineColors)) {
                        _newState.captions[i].lineColors.splice(action.payload.lineIndex, 1)
                        if (_newState.captions[i].lineColors[0]) {
                            _newState.captions[i].fontColor = _newState.captions[i].lineColors[0]
                        }
                    } else {
                        _newState.captions[i].lineColors = Array(_newState.captions[i].text.length).fill(_newState.captions[i].fontColor)
                    }
                }
                catch (e) {
                    console.log(e)
                }
            }
            break;

        case SLIDE.CHANGE_PAUSE_BETWEEN_LINES:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                const lastIndex = action.payload.captionSelectedArray[action.payload.captionSelectedArray.length - 1]
                if (
                    _newState.captions[lastIndex].animationIn === 'typing'
                    || _newState.captions[lastIndex].animationIn.includes('countdown')
                    || _newState.captions[lastIndex].animationIn.includes('credits')
                ) {
                    // if (_newState.captions[lastIndex].animationIn === 'typing') {
                    _newState.captions[index].pauseBetweenLines = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_SELECTED_LINE:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.editingCaptionIndex].selectedLine = action.payload.newVal
            _newState.captions[action.payload.editingCaptionIndex].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
            break;


        //===================================!!!Text!!!=========================================


        case SLIDE.CHANGE_CAPTION_TEXT:
            _newState = _.cloneDeep(state)
            _newState.captions[action.payload.captionIndex].text = action.payload.newText
            _newState.captions[action.payload.captionIndex].captionRandomKey = Date.now()
            break;

        case SLIDE.CHANGE_TEXT_ALIGN:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].style.textAlign = action.payload.newAlign
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_FONT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].fontFamily = action.payload.newFont
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_FONT_COLOR:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    if (
                        (_newState.captions[index].animationIn.includes('countdown') || _newState.captions[index].animationIn.includes('credits'))
                        && Array.isArray(_newState.captions[index].text)
                    ) {
                        const textArrLength = _newState.captions[index].text.length
                        let lineColorsArray = Array.isArray(_newState.captions[index].lineColors) ? [..._newState.captions[index].lineColors] : []

                        if (Array.isArray(lineColorsArray) && lineColorsArray.length < textArrLength) {
                            lineColorsArray = [...lineColorsArray, ...Array(textArrLength - lineColorsArray.length).fill(_newState.captions[index].fontColor)]
                        }
                        // ставлю цвет только для выбранной строки. Если в других позициях не будет цвета, 
                        // то при рендере будет браться цвет из общей строки для других анимаций
                        lineColorsArray[_newState.captions[index].selectedLine || 0] = action.payload.newColor
                        _newState.captions[index].lineColors = [...lineColorsArray]
                        // ставлю нестрогое равенство на случай, если линия не определена (такого быть не должно, но...)
                        if (_newState.captions[index].selectedLine == 0) {
                            _newState.captions[index].fontColor = action.payload.newColor
                        }
                    }
                    else {
                        _newState.captions[index].fontColor = action.payload.newColor
                        if (_newState.captions[index].lineColors) {
                            _newState.captions[index].lineColors[0] = action.payload.newColor
                        }
                    }
                    _newState.captions[index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_FONT_COLOR_HOVER:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].fontColorHover = action.payload.newColor
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_FONT_SIZE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    switch (action.payload.viewType) {
                        case 'desktop':
                            _newState.captions[index].fontSize = action.payload.diffVal === null ? action.payload.newVal : _newState.captions[index].fontSize + action.payload.diffVal
                            break;

                        case 'mobile':
                            _newState.captions[index].mobileFontSize = action.payload.diffVal === null || !_newState.captions[index].mobileFontSize ? action.payload.newVal : _newState.captions[index].mobileFontSize + action.payload.diffVal
                            break;
                    }
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_LINE_HEIGHT:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    switch (action.payload.viewType) {
                        case 'desktop':
                            _newState.captions[index].lineHeight = action.payload.diffVal === null ? action.payload.newVal : _newState.captions[index].lineHeight + action.payload.diffVal
                            break;

                        case 'mobile':
                            _newState.captions[index].mobileLineHeight = action.payload.diffVal === null ? action.payload.newVal : _newState.captions[index].mobileLineHeight + action.payload.diffVal
                            break;
                    }
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_LETTER_SPACING:
            _newState = _.cloneDeep(state)

            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    switch (action.payload.viewType) {
                        case 'desktop':
                            _newState.captions[index].letterSpacing = action.payload.diffVal === null ? action.payload.newVal : _newState.captions[index].letterSpacing + action.payload.diffVal
                            break;

                        case 'mobile':
                            _newState.captions[index].mobileLetterSpacing = action.payload.diffVal === null ? action.payload.newVal : _newState.captions[index].mobileLetterSpacing + action.payload.diffVal
                            break;
                    }
                }
            })
            break;

        case SLIDE.CHANGE_LETTER_CASE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].letterCase = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_ITALIC:
            _newState = _.cloneDeep(state)
            action.payload.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].style.italic = !_newState.captions[index].style.italic
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_BOLD:
            _newState = _.cloneDeep(state)
            action.payload.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].style.bold = !_newState.captions[index].style.bold
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_UNDERLINE:
            _newState = _.cloneDeep(state)
            action.payload.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].style.underline = !_newState.captions[index].style.underline
                    if (_newState.captions[index].style.strikethrough) {
                        _newState.captions[index].style.strikethrough = false
                    }
                }
            })
            break;
        case SLIDE.CHANGE_CAPTION_STRIKETHROUGH:
            _newState = _.cloneDeep(state)
            action.payload.map((index) => {
                if (_newState.captions[index].type !== 'box' && _newState.captions[index].type !== 'shape') {
                    _newState.captions[index].style.strikethrough = !_newState.captions[index].style.strikethrough
                    if (_newState.captions[index].style.underline) {
                        _newState.captions[index].style.underline = false
                    }
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_HAS_SHADOW:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].hasShadow = action.payload.newVal
            })
            break;

        case SLIDE.CHANGE_CAPTION_SHADOW:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].shadow = action.payload.newVal
            })
            break;

        case SLIDE.CHANGE_BUTTON_TEXT_HAS_SHADOW:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'button') {
                    _newState.captions[index].textHasShadow = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_BUTTON_TEXT_SHADOW:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'button') {
                    _newState.captions[index].textShadow = action.payload.newVal
                }
            })
            break;

        case SLIDE.ROTATE_CAPTION:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'text') {
                    _newState.captions[index].rotateAngle = action.payload.newVal
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_SHAPE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'box' || _newState.captions[index].type === 'shape') {
                    _newState.captions[index].shape = action.payload.newVal
                }
            })
            break;

        case SLIDE.TOGGLE_RTL:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (_newState.captions[index].type === 'text' || _newState.captions[index].type === 'button') {
                    _newState.captions[index].isRTL = action.payload.newVal
                    let style = _newState.captions[index].style || { bold: false, italic: false, underline: false, textAlign: 'left' }
                    let textAlign = style.textAlign || 'left'

                    // if (_newState.captions[index].fontFamily && _newState.captions[index].fontFamily.custom) {
                    if (action.payload.newVal && textAlign === 'left') {
                        _newState.captions[index].style.textAlign = 'right'
                    } else if (!action.payload.newVal && textAlign === 'right') {
                        _newState.captions[index].style.textAlign = 'left'
                    }
                    // }
                }
            })
            break;

        //=====================!!!Action and history!!!===========================================

        case SLIDE.ADD_ACTION:
            _newState = _.cloneDeep(state)
            if (_newState.actions.length > 24 && _newState.actionIndex >= 24) {
                _newState.actions.shift()
            }
            if (_newState.actionIndex < 24) {
                _newState.actionIndex++
            }

            if (_newState.actionIndex > 0) {
                sessionStorage.setItem(`edit-slide-actions`, 'true')
            }

            actionForHistory = {
                captions: _newState.captions,
                backgroundColor: _newState.backgroundColor,
                backgroundType: _newState.backgroundType,
                backgroundGradient: _newState.backgroundGradient,
                hasBackgroundShadow: _newState.hasBackgroundShadow,
                backgroundShadow: _newState.backgroundShadow,
            }
            _newState.actions.splice(_newState.actionIndex, _newState.actions.length - _newState.actionIndex)
            _newState.actions.push(_.cloneDeep(actionForHistory))
            _newState.rerenderRightPanelSetting = Date.now()
            break;

        case SLIDE.CLEAR_ACTIONS_HISTORY:
            _newState = _.cloneDeep(state)
            _newState.actions = []
            _newState.actionIndex = -1
            break;

        case SLIDE.UNDO:
            _newState = _.cloneDeep(state)
            if (_newState.actionIndex > 0) {
                _newState.actionIndex--
            }
            _newState.captions = _.cloneDeep(_newState.actions[_newState.actionIndex].captions)
            // _newState.slideName = _newState.actions[_newState.actionIndex].slideName
            _newState.backgroundColor = _newState.actions[_newState.actionIndex].backgroundColor
            _newState.backgroundType = _newState.actions[_newState.actionIndex].backgroundType
            _newState.backgroundGradient = _newState.actions[_newState.actionIndex].backgroundGradient
            _newState.hasBackgroundShadow = _newState.actions[_newState.actionIndex].hasBackgroundShadow
            _newState.backgroundShadow = _newState.actions[_newState.actionIndex].backgroundShadow
            _newState.rerenderRightPanelSetting = Date.now()
            break;

        case SLIDE.REDO:
            _newState = _.cloneDeep(state)
            _newState.captions = _.cloneDeep(_newState.actions[++_newState.actionIndex].captions)
            // _newState.slideName = _newState.actions[_newState.actionIndex].slideName
            _newState.backgroundColor = _newState.actions[_newState.actionIndex].backgroundColor
            _newState.backgroundType = _newState.actions[_newState.actionIndex].backgroundType
            _newState.backgroundGradient = _newState.actions[_newState.actionIndex].backgroundGradient
            _newState.hasBackgroundShadow = _newState.actions[_newState.actionIndex].hasBackgroundShadow
            _newState.backgroundShadow = _newState.actions[_newState.actionIndex].backgroundShadow
            _newState.rerenderRightPanelSetting = Date.now()
            break;


        //=====================!!!Order, layer and align!!!===========================================

        case SLIDE.CHANGE_CAPTION_ORDER:
            _newState = _.cloneDeep(state)
            _newState.captions = action.payload
            break;

        case SLIDE.CHANGE_LAYER:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (action.payload.actionType == 'nextLayer') {
                    ++_newState.captions[index].layer
                } else {
                    if (_newState.captions[index].layer > 1) {
                        --_newState.captions[index].layer
                    }
                }

                _newState.captions[index].layer = _newState.captions[index].layer
            })
            break;

        case SLIDE.CHANGE_CAPTION_ALIGN:
            _newState = _.cloneDeep(state)
            const positionProp = action.payload.deviceType === 'mobile' ? 'mobilePosition' : 'position'
            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index][positionProp] = action.payload.newPositions.get(index) || _newState.captions[index][positionProp]
                _newState.captions[index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                if (action.payload.deviceType === 'mobile' && _newState.captions[index].needMobileConvert) {
                    delete _newState.captions[index].needMobileConvert
                }
            })
            break;

        case SLIDE.CHANGE_CAPTION_MOBILE_SHOW:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].mobileShow = action.payload.newVal
            })
            break;

        case SLIDE.TOGGLE_CAPTION_HIDE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                if (action.payload.isMobile) {
                    _newState.captions[index].mobileHidden = action.payload.newVal
                } else {
                    _newState.captions[index].desktopHidden = action.payload.newVal
                }
            })
            break;


        case SLIDE.DELETE_TOAST:
            _newState = _.cloneDeep(state)
            _newState.toasts.splice(action.payload, 1)
            break;

        case SLIDE.ERROR_OFF:
            _newState = _.cloneDeep(state)
            _newState.error = false
            break;

        case SLIDE.TOGGLE_PARALLAX:
            _newState = _.cloneDeep(state)
            _newState.hasParallax = action.payload
            break;

        case SLIDE.CHANGE_PARALLAX_IMAGE:
            _newState = _.cloneDeep(state)
            _newState.parallaxImage = action.payload
            break;

        case SLIDE.APPLY_PARALLAX_CROP:
            _newState = _.cloneDeep(state)
            _newState.parallaxImage = action.payload
            break;

        case SLIDE.TOGGLE_SEPARATE_CORNERS:
            _newState = _.cloneDeep(state)
            _newState.separateCorners = action.payload
            action.payload.captionSelectedArray.map((index) => {
                if (action.payload.isMobile) {
                    _newState.captions[index].separateCornersMobile = action.payload.bool
                } else {
                    _newState.captions[index].separateCorners = action.payload.bool
                }
            })
            break;
        case SLIDE.CHANGE_HTML_TAG:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map((index) => {
                _newState.captions[index].htmlTag = action.payload.newVal
            })
            break;

        case SLIDE.TOGGLE_BUTTON_ICON:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (!_newState.captions[index].iconSettings) {
                    _newState.captions[index].iconSettings = {
                        margin: 5,
                        size: 25,
                        icon: 'circle-o',
                        location: 'left',
                        animation: 'forward',
                        isCustom: false
                    }
                    const width = _newState.captions[index].width
                    _newState.captions[index].width = width + 30
                    _newState.captions[index].captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                }
                _newState.captions[index].iconOn = action.payload.value

            })
            break;
        case SLIDE.CHANGE_BUTTON_ICON:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                _newState.captions[index].iconSettings.icon = action.payload.value
                _newState.captions[index].iconSettings.isCustom = action.payload.isCustom
            })
            break;
        case SLIDE.CHANGE_BUTTON_ICON_LOCATION:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                _newState.captions[index].iconSettings.location = action.payload.value
            })
            break;
        case SLIDE.CHANGE_BUTTON_ICON_MARGIN:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (action.payload.isMobile) {
                    _newState.captions[index].iconSettings.mobileMargin = action.payload.value
                } else {
                    _newState.captions[index].iconSettings.margin = action.payload.value
                }
            })
            break;
        case SLIDE.CHANGE_BUTTON_ICON_SIZE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (action.payload.isMobile) {
                    _newState.captions[index].iconSettings.mobileSize = action.payload.value
                } else {
                    _newState.captions[index].iconSettings.size = action.payload.value
                }
            })
            break;
        case SLIDE.CHANGE_BUTTON_ICON_ANIMATION:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                _newState.captions[index].iconSettings.animation = action.payload.value
            })
            break;

        case SLIDE.TOGGLE_BUTTON_ANIMATION:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                _newState.captions[index].buttonAnimationOn = action.payload.value
            })
            break;
        case SLIDE.TOGGLE_BUTTON_ICON_ANIMATION:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                _newState.captions[index].buttonIconAnimationOn = action.payload.value
            })
            break;
        case SLIDE.CHANGE_CAPTION_STRIPES_COLOR:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (_newState.captions[index].type === 'text' && _newState.captions[index].animationIn === 'stripes') {
                    _newState.captions[index].stripesColor = action.payload.value
                }
            })
            _newState.rerenderRightPanelSetting = Date.now()
            break;
        case SLIDE.CHANGE_CAPTION_STRIPES_SPEED:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (_newState.captions[index].type === 'text' && _newState.captions[index].animationIn === 'stripes') {
                    _newState.captions[index].stripesSpeedMultiplier = action.payload.value
                }
            })
            break;
        case SLIDE.CHANGE_CAPTION_TYPEWRITER_CURSOR:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (_newState.captions[index].type === 'text' && _newState.captions[index].animationIn === 'typing') {
                    _newState.captions[index].typewriterCursor = action.payload.value
                }
            })
            break;
        case SLIDE.CHANGE_CAPTION_SEO_TEXT:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (_newState.captions[index].type === 'image') {
                    _newState.captions[index].seoText = action.payload.value
                }
            })
            break;
        case SLIDE.SET_TEXT_STROKE_SIZE:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (!_newState.captions[index].textStroke) {
                    _newState.captions[index].textStroke = {
                        color: `rgba(255, 0, 0, .5)`,
                        size: 0
                    }
                }
                if (action.payload.isMobile) {
                    _newState.captions[index].textStroke.mobileSize = action.payload.value
                } else {
                    _newState.captions[index].textStroke.size = action.payload.value
                }
            })
            break;
        case SLIDE.SET_TEXT_STROKE_COLOR:
            _newState = _.cloneDeep(state)
            action.payload.captionSelectedArray.map(index => {
                if (!_newState.captions[index].textStroke) {
                    _newState.captions[index].textStroke = {
                        color: `rgba(255, 0, 0, .5)`,
                        size: 0
                    }
                }
                const colorArray = hexToRgba(action.payload.value.color)
                colorArray[3] = action.payload.value.opacity
                _newState.captions[index].textStroke.color = colorArray.toString()
            })
            break;
        case SLIDE.HIDE_SHOW_CAPTIONS_OUTSIDE:
            _newState = _.cloneDeep(state)
            action.payload.captionsToHide.map(index => {
                _newState.captions[index].hiddenOutOfBounds = true
            })
            action.payload.captionsToShow.map(index => {
                _newState.captions[index].hiddenOutOfBounds = false
            })
            break;
        default:
            _newState = _.cloneDeep(state);
            break;
    }
    return _newState
}


export { slideReducer }